import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import VideoGridSection from "@/pages/home/components/VideoGridSection";
import IntroSection from "@/pages/home/components/IntroSection";
import { videos } from "@/mocks/videos";

export default function Home() {
  const latest = [...videos]
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, 8);

  const popular = [...videos]
    .sort((a, b) => b.views - a.views)
    .slice(0, 4);

  return (
    <>
      <HeroCarousel />
      <CategoryEntries />
      <VideoGridSection
        title="最新视频"
        subtitle="按发布时间倒序，第一时间看到主播的新鲜作品。"
        videos={latest}
        moreTo="/search"
        moreLabel="查看全部视频"
      />
      <VideoGridSection
        title="热门推荐"
        subtitle="综合播放量与点赞数，挑选出最受欢迎的高光内容。"
        videos={popular}
        moreTo="/category/game"
        moreLabel="进入分类浏览"
        showRank
      />
      <IntroSection />
    </>
  );
}